import React from 'react';
import {thinMargins} from '../../constants';
import {Feature} from '../../types';
import {GatsbyImage} from 'gatsby-plugin-image';
import {StructuredTextDocument} from 'react-datocms/structured-text';
import {StyledStructuredText} from '../../components/common/StyledStructuredText';
import {MobileFeatureSelector} from '../homepage';

const AboutUsText = ({
  title,
  explainer,
}: {
  title: string;
  explainer?: {value: StructuredTextDocument};
}) => {
  return (
    <div className="text-black">
      <h2 className="text-subtitlelargemob md:text-subtitlelarge font-bold">
        {title}
      </h2>
      {/* Deprecated and replaced with explainer structred text */}
      {/* <p className="text-largebodymob md:text-smallbody pt-2 md:pt-6">{text}</p> */}
      {explainer && (
        <div className="text-largebodymob md:text-smallbody pt-2 md:pt-6">
          <StyledStructuredText
            data={explainer.value as unknown as StructuredTextDocument}
          />
        </div>
      )}
    </div>
  );
};

interface IAboutUsHeader {
  aboutUsBlocks: Feature[];
  title: string;
}

export const AboutUsHeader = ({aboutUsBlocks, title}: IAboutUsHeader) => {
  return (
    <div className={`${thinMargins} text-black md:pb-16`}>
      <h1 className="text-h3mob md:text-h2 font-title text-center lg:text-start">
        {title}
      </h1>
      <div className="hidden md:flex pt-20 gap-24">
        <div className="w-1/2 flex flex-col justify-between">
          <AboutUsText
            title={aboutUsBlocks[0].title}
            explainer={aboutUsBlocks[0].explainer}
          />

          {aboutUsBlocks[1].image && (
            <GatsbyImage
              alt={aboutUsBlocks[1].image?.alt || ''}
              image={aboutUsBlocks[1].image?.gatsbyImageData}
              className="mt-10 min-h-[27rem] w-full h-fill mx-auto object-cover rounded-[2rem]"
              draggable={false}
            />
          )}
        </div>
        <div className="w-1/2 flex flex-col justify-between">
          {aboutUsBlocks[0].image && (
            <GatsbyImage
              alt={aboutUsBlocks[0].image?.alt || ''}
              image={aboutUsBlocks[0].image?.gatsbyImageData}
              className="mb-10 min-h-[27rem] w-full mx-auto object-cover rounded-[2rem]"
              draggable={false}
            />
          )}
          <AboutUsText
            title={aboutUsBlocks[1].title}
            explainer={aboutUsBlocks[1].explainer}
          />
        </div>
      </div>
      <div className="hidden md:flex pt-10 gap-24">
        <div className="w-1/2 flex flex-col justify-between">
          <AboutUsText
            title={aboutUsBlocks[2].title}
            explainer={aboutUsBlocks[2].explainer}
          />

          {aboutUsBlocks[3].image && (
            <GatsbyImage
              alt={aboutUsBlocks[3].image?.alt || ''}
              image={aboutUsBlocks[3].image?.gatsbyImageData}
              className="mt-10 min-h-[24rem] max-h-[30rem] w-full mx-auto object-cover rounded-[2rem]"
              draggable={false}
            />
          )}
        </div>
        <div className="w-1/2 flex flex-col justify-between">
          {aboutUsBlocks[2].image && (
            <GatsbyImage
              alt={aboutUsBlocks[2].image?.alt || ''}
              image={aboutUsBlocks[2].image?.gatsbyImageData}
              className="mb-10 min-h-[27rem] w-full mx-auto object-cover rounded-[2rem]"
              draggable={false}
            />
          )}
          <AboutUsText
            title={aboutUsBlocks[3].title}
            explainer={aboutUsBlocks[3].explainer}
          />
        </div>
      </div>
      <div className="py-8 md:hidden">
        <MobileFeatureSelector features={aboutUsBlocks} context="about" />
      </div>
    </div>
  );
};
